import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './style.module.less';

@withRouter
@BindAll()
export class ClauseRegistered extends React.Component {
  state = {
    countdown: null,
    disabled: false,
  };

  get isVisible() {
    return lodash.eq(lodash.get(this.$router.query, 'clause'), 'registered');
  }

  initCountdown () {
    this.setState({
        disabled: true,
        countdown: Date.now() + 1000 * 6,
    })
  }

  hideModal = () => {
    this.$MergeQuery({clause: ''}, true)
    this.initCountdown()
  };

  componentDidUpdate(prevProps, prevState) {
    if(lodash.get(this.$router.query, 'clause') !== lodash.get(prevProps, 'location.query.clause')) {
        this.initCountdown()
    }
  }
  
  onCountdownFinish() {
    this.setState({
        disabled: false,
    })
  }
  
  renderCountDown() {
    if(this.state.disabled) {
        return <div className={styles.countdown}>
            <span>确认(</span>
            <React.Antd.Countdown
              onFinish={this.onCountdownFinish}
              value={this.state.countdown}
              format="ss"
              suffix="s"
              key="countdown"
            />
            <span>)</span>
        </div>  
    }
    return <span>确认</span>
  }
  render() {
    return (
      <React.Antd.Modal
        title="大联想伙伴网注册协议"
        visible={this.isVisible}
        onOk={this.hideModal}
        okText="确认"
        width={800}
        closable={false}
        footer={[
          <React.Antd.Button disabled={this.state.disabled} type='primary' key="ok" onClick={this.hideModal}>{this.renderCountDown()}</React.Antd.Button>
        ]}
      >
        <div className={styles.agreementContent}>
          <p style={{ textAlign: 'justify' }}>
            <span style={{ fontSize: '29px' }}>
              <strong style={{ fontFamily: '宋体' }}>
                合作伙伴网络注册协议
              </strong>
            </span>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              重要提醒━请仔细阅读本文件！
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>====================</p>
          <p style={{ textAlign: 'justify' }}>
            本合作伙伴网络注册协议包括援引的其他条款（统称为"本协议"）由结尾所列联想集团所属企业（"联想"）与联想合作伙伴网络计划参加成员（"贵方"）签署。"贵方"是指任何个人或单一法律实体。贵方与联想在本协议中合称"双方"，单独称为"一方"。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>1.0 目的</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            联想合作伙伴网络计划（"计划"）的目的是为贵方提供与联想产品和服务相关的营销、商机、教育、培训和拓展支持材料及和/或其他相关信息。本计划旨在为那些销售或推广联想产品和服务的合作伙伴提供支持。所有计划、材料、利益和成员等级及其相关条款、条件和要求均应在用于支持本计划的联想网站或联想正式发布的信息中说明。贵方应满足并保持联想规定的资格要求。除非贵方与联想另外达成了联想渠道协议或其他明确规定了联想产品或服务转售条款和条件的其他协议，否则贵方不得基于本协议购买联想产品和服务用于转售。
          </p>
          <p style={{ textAlign: 'justify' }}>
            本协议中，"产品"是指任何联想或第三方品牌的硬件或软件。软件包括计算机软件程序（无论是预装的还是单独提供的）和相关的许可材料，如文件。"服务"是指执行一项任务、提供咨询或协助或提供资源（例如信息数据库）的访问权。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>2.0 接受本协议</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            2.1
            贵方必须接受本协议条款方可获得成为联想合作伙伴网络计划参加成员的资格。贵方可通过以下方式接受本协议：（1）点击确认选择接受或同意本协议；或（2）有效签署本协议的纸质文档，并交付给联想。
          </p>
          <p style={{ textAlign: 'justify' }}>
            2.2
            如任何个人代表他人（包括某个实体或从事经营活动的个人）确认接受本协议，该个人声明并保证其已经获得了所代表实体或个人充分的授权，并有资格这样做。
          </p>
          <p style={{ textAlign: 'justify' }}>
            2.3
            贵方接受本协议并后，贵方经联想审核批准后，方可成为联想合作伙伴网络计划成员。
          </p>
          <p style={{ textAlign: 'justify' }}>
            2.4
            本协议并不取替贵方与联想和/或双方各自关联机构之间签署的渠道合作协议及相关附属合同文件。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>3.0 合作伙伴账户注册</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            3.1
            为执行本计划，贵方需要依照联想账户注册流程创立一个贵方自己的账户("账户")。贵方可能被允许注册或使用联想账户（例如，联想通行证）或第三方平台上注册的账户（例如，联想通行证），此时贵方会受适用于该联想或第三方账户的法律条款的约束。
          </p>
          <p style={{ textAlign: 'justify' }}>
            3.2
            贵方同意，在账户注册过程中以及在此后联想要求时，将向联想提供真实、准确、最新和完整的必要账户管理信息和数据（如贵方名称、地址、工商及税务信息、贵方代表的姓名、电子邮件地址及电话号码等，统称为"注册信息"）。贵方应始终维护并随时及时更新贵方的光的注册信息。如果贵方提供的注册信息虚假、不正确、不完整或已经过时，可能会影响贵方对联想网站的使用以及联想合作伙伴网络计划的执行。
          </p>
          <p style={{ textAlign: 'justify' }}>
            3.3
            根据贵方需要，贵方可将上述贵方账号设置为主账号，贵方授权的贵方账号管理员可以根据联想的账号管理规则，在贵方账号下创建并管理若干个子账号。贵方子账号属于贵方账号的组成部分，贵方子账号的行为均属于贵方账号的行为。贵方应确保子账号的创建、使用均符合本协议的规定，贵方并应对贵方子账号的所有行为负责。
          </p>
          <p style={{ textAlign: 'justify' }}>
            3.4
            签署本协议，并不取替贵方与联想或联想关联机构签署的渠道合作协议及相关渠道合作协议销售政策。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>4.0 账户和密码安全</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            4.1
            贵方应自行负责妥善保管贵方的登录信息和密码。无论是否经过贵方授权，对通过贵方账户进行的或在贵方账户中发生的所有活动，均应由贵方自行负责。如发现对贵方账户的任何未经授权的使用或发生其他此类安全问题，贵方应立即告知我们。对他人未经授权使用贵方的帐户，联想不承担任何责任。
          </p>
          <p style={{ textAlign: 'justify' }}>
            4.2
            账户由确认和接受本协议的人拥有。如此后账户所有权发生变化，应有相关法律文件证明。联想不对与账户内部活动及账户所有权相关的争议进行判定。如不能确定账户的有效所有者，联想有权暂停或取消该账户。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>5.0 合作伙伴的义务</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>5.1 贵方应负责以下事项：</p>
          <p style={{ textAlign: 'justify' }}>
            （a）客户对贵方的所有活动满意；
          </p>
          <p style={{ textAlign: 'justify' }}>
            （b）根据联想合理要求，向联想提供有关贵方及贵方履行本协议情况的信息；
          </p>
          <p style={{ textAlign: 'justify' }}>
            （c）在向联想披露个人身份信息之前，履行任何适用的通知或同意要求；
          </p>
          <p style={{ textAlign: 'justify' }}>
            （d）仅为支持本协议项下活动而使用联想信息系统；
          </p>
          <p style={{ textAlign: 'justify' }}>
            （e）避免为了直接或间接影响有利于联想的决策而向任何人支付任何形式的款项或礼物；以及
          </p>
          <p style={{ textAlign: 'justify' }}>
            （f）贵方要求参加本计划时所提供的信息如发生任何重大变更及时通知联想。
          </p>
          <p style={{ textAlign: 'justify' }}>
            （g）在使用本网站过程中，贵方确保所上传、维护、提供的信息准确、有效、完整，并自行承担相应法律责任或义务。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>6.0 网站使用政策</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.1
            贵方在执行本计划时应遵守本协议及所有可适用的联想网站使用条款（见联想网站法律条款）。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.2
            贵方不得为任何非法、欺诈、不当或滥用的目的或以任何可能妨碍其他用户使用联想网站或损害联想或其他用户的任何财产以及侵犯或妨害第三方权利的方式使用联想网站。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.3
            贵方对联想网站的使用应遵循所有相关的国家、地方、国际和国内法律的规定。如联想网站允许贵方上传任何文字、图形及音视频等内容，贵方应保证这些内容不违反任何法律规定，不侵犯任何联想及第三方的知识产权、肖像权、名誉权、隐私权及其他任何权利。联想保留删除或编辑任何不当内容的权利（非义务），但联想不负责监控或审查贵方在联想网站上发布或发送的信息，对贵方传递任何此类信息不承担任何责任。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.4
            对因贵方使用联想网站以及贵方违反使用政策导致的损失、损害及其他后果，由贵方自行负责。贵方同意为联想及其供应商提供补偿、抗辩并确保其不因贵方的数据、贵方对软件或服务的使用或贵方违反本协议条款所导致的任何损失、成本、责任及其他费用而受到损害。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <a href="" target="">
              <span style={{ color: 'red' }}>6.5 </span>
            </a>
            贵方使用本网站交易功能与联想其他合作伙伴执行任何交易，按贵方与交易对方之间协商确定的条款和条件执行，如贵方与交易对方未就相关交易确定任何条款和条件，则《联想合作伙伴网站买卖合同一般条款》适用于相关交易，贵方应按该条款执行相关交易。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.6
            贵方了解，联想网站公布的价格仅适用于联想向合作伙伴的直接销售，不构成对贵方与交易对方之间交易价格的限制，贵方与交易对方之间的交易价格将由贵方与交易对方自行商定。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.7
            以本协议第15条为前提，本网站仅为业务方便的目的部署了支付功能，相关支付服务由持有合法牌照的第三方互联网支付服务商提供，贵方使用第三方互联网支付服务，需另外接受第三方互联网支付服务商的法律条款并受其约束，贵方应按第三方支付服务商的相关流程接收和支付款项及使用其他相关服务。联想对第三方支付服务，包括贵方是否能够成功支付或收妥相关价款，不提供任何陈述、保证和担保，也不承担任何义务和责任。
            请贵方根据自己的判断选择使用第三方支付服务，并自行确保资金安全。如您不接受第三方支付服务商的条款和服务，可选择其他方式结算贵方与其他合作伙伴之间的价款。
          </p>
          <p style={{ textAlign: 'justify' }}>
            6.8
            贵方应依法使用网站部署的支付服务，不得使用支付服务从事任何包括洗钱、赌博、非法集资、非法药品交易等在内的任何违法活动。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>7.0 贵方数据的存储</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            7.1
            贵方上传至联想网站、在联想网站存储、或通过联想网站发送或接受的贵方数据，其中可能包含贵方的任何个人数据（"贵方数据"），其所有权均由贵方保留，除非经贵方的事先同意和允许，否则联想不会自己或允许他人使用贵方数据。
          </p>
          <p style={{ textAlign: 'justify' }}>
            7.2
            贵方通过联想网站上传、存储、传送或接收贵方数据，视为贵方授予联想及其服务提供商一个全球范围的许可，使其可以仅为执行计划的目的，复制并以加密方式存储贵方数据。贵方应确保贵方拥有所有必要的权利和权力授予上述许可。
          </p>
          <p style={{ textAlign: 'justify' }}>
            7.3
            除非联想另有明确说明，否则为贵方数据提供存储不是联想的义务，为此，贵方知道并同意，联想将不对数据无论因任何原因被删除或存储失败承担责任。贵方应自行负责及时和妥善地对贵方数据进行备份。贵方知道并同意，我们可能会对贵方上传或存储的贵方数据的数量和期限设置限制。
          </p>
          <p style={{ textAlign: 'justify' }}>
            7.4
            如本协议因任何原因终止的，贵方可在终止后不超过三十（30）天内下载或移除可能存于联想网站上的贵方数据。除非法律另有强制要求，否则上述期限届满后，贵方数据将根据联想的判断被安全迁移或销毁。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              8.0 数据收集、使用及隐私权保护
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            8.1
            在注册联想账户或登录联想网站时，贵方可能会被要求提供注册信息，其中将包含贵方人员的个人身份信息。为履行本协议，我们可能会收集贵方或要求贵方提供有关贵方及贵方人员的数据和信息。贵方同意联想可以根据其隐私权政策，自行或允许其服务提供商为履行本协议的目的而使用这些信息。贵方同意联想可以在符合相关法律规定的前提下，在贵方所在国家或地区之外存储和传输上述数据和信息。这些信息仅为履行本协议的目的使用。
          </p>
          <p style={{ textAlign: 'justify' }}>
            8.2
            贵方同意联想可以为履行本协议的目的，通过电子邮件或消息弹窗等方式向贵方发送一些公告、管理信息以及其他与本计划有关的服务和支持信息。
          </p>
          <p style={{ textAlign: 'justify' }}>
            贵方可登录以下联想网站阅读适用于贵方所在国家或地区的联想隐私权政策声明,了解我们收集、使用、存储和处理贵方信息及数据相关政策的详情。
          </p>
          <p style={{ textAlign: 'justify' }}>
            联想隐私权声明：https://www.lenovo.com.cn/statement/privacy.html
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>9.0 保密信息</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.1
            本协议签署前以及在本协议期限内，一方（"披露方"）可能已经或将要向对方（"接受方"）披露该方的商业、营销、技术、业务或其他资料，这些资料在披露当时被指定为保密信息（或类似标注），或者在保密的情况下披露，或者经各方的合理商业判断为保密信息（"保密信息"）。在本协议期限内及本协议终止后[三（3）]年内，接受方必须：（A）对保密信息进行保密；（B）不为除本协议规定的目的之外的其他目的使用保密信息；且（C）除为履行其职责而确有必要知悉保密信息的该方雇员（或其关联机构、该方律师、会计师或其他顾问的雇员）外，不向其他任何人披露，且上述人员须签署书面保密协议，其中保密义务的严格程度不得低于本条的规定。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.2
            上款规定的义务对以下信息不适用：（A）在披露时已属于或在披露后进入公共领域的信息，但因接收方违反保密义务所导致的除外；（B）在披露时接收方已经掌握的且对其不承担保密义务的信息；（C）在未违反本协议的情况下接收方从披露方之外的来源获得的信息；（D）由披露方在未附带保密义务的情况下提供给第三方的信息；或（E）接收方未利用披露方披露的信息独立开发的信息。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.3
            本协议终止后，或根据披露方随时提出的要求，接收方应：（A）向披露方归还（或经对方要求销毁）包含披露方保密信息的所有材料（包括其复制件），并且（B）在披露方提出要求后十（10）日内，向披露方书面保证接收方已经归还或销毁上述资料。尽管有上述规定，接收方不需修改、删除或销毁在正常业务执行过程中形成的备份磁带或其他电子媒体。如接收方选择为存档目的保留保密信息副本，或在备份媒介中留存有保密信息，则只要存档或留存的保密信息仍处于保密状态，本协议项下保持保密信息机密性以及仅按本协议允许使用保密信息的所有义务，将继续具有完全和充分的效力。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.4 任何一方的保密信息按"现状"提供，不作任何形式的保证。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.5
            任何一方接收保密信息不应妨碍或以任何方式限制接收方从事以下行为：（a）向他人提供可能与披露方的产品或服务竞争的产品或服务；（b）向与披露方竞争的其他人提供产品或服务；或（c）根据其自己的判断分配员工。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.6
            任何一方均可基于法律强制要求，在法律强制要求的范围内披露另一方的保密信息，但应立即将任何此类要求通知另一方。
          </p>
          <p style={{ textAlign: 'justify' }}>
            9.7
            如各方就本协议项下活动另外签署了保密协议，则双方就活动所交流的信息依该协议保护。在不限制本协议任何规定的条件下，保密义务适用于所有规格、需求和支持文件。本协议条款和条件应视为保密信息。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>10.0 知识产权</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            10.1
            贵方同意授予联想所有必要的许可和权利，据此联想可以自己及允许其关联机构和网站服务商将贵方资料数据用于提供本网站服务和活动。联想不会更改贵方所提供商标的规格，但可为推广介绍目的对商标大小做必要调整。联想将根据贵方的合理请求移除贵方指明的特定材料。尽管如此，本协议的任何内容均不影响联想根据法律合理使用原则在无需征得贵方同意情况下使用贵方数据材料的权利。
          </p>
          <p style={{ textAlign: 'justify' }}>
            10.2
            贵方可根据联想不时的书面授权，为履行本协议的目的使用联想商标。贵方对联想商标的使用应完全符合联想的相关商标使用规范指南，不得做任何修改。
          </p>
          <p style={{ textAlign: 'justify' }}>
            10.3
            贵方应自行承担费用对不符合联想规范标准的任何广告或促销材料进行修改。如贵方收到任何与其使用联想商标有关的任何投诉，应立即通知联想。本协议终止后，贵方应立即停止使用联想商标。如贵方未能停止使用，应赔偿联想为促使贵方停止使用而发生的所有法律费用包括合理律师费。
          </p>
          <p style={{ textAlign: 'justify' }}>
            10.4
            贵方不得注册或使用与联想商标类似的任何标志。联想商标以及贵方使用该等标志所产生的任何商誉，均为联想的独家财产。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>11.0 无保证声明</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            11.1
            除非联想另有明确规定，否则本协议项下提供的任何材料及服务均以"按现状"且"可用"为基础提供，无任何保证。在法律允许的最大限度内，我们明确否认任何包括但不限于有关适销性、适用于某个特定目的、权属以及不侵权在内的明示、默示及法定的保证以及任何有关安全、可靠性、及时性和材料及服务性能的保证。以上排除和限制同时适用于任何联想的供应商及分销商。
          </p>
          <p style={{ textAlign: 'justify' }}>
            11.2
            某些国家或司法管辖区不允许排除或限制某些默示保证，此时以上排除和限制将不适用于贵方。
          </p>
          <p style={{ textAlign: 'justify' }}>
            11.3
            贵方了解并同意，联想不是贵方基于本网站所获得信息与本网站其他参加成员所达成任何交易的参与方，如贵方与其他参加成员之间就此类交易出现任何争议，联想可以（但不作为联想的义务）协助居中协调处理，但对于因此类争议引起的或与之相关的任何类型和性质的索赔、要求和损害赔偿（包括实际发生的和间接的），联想和/或及其其服务商及其各自人员（包括但不限于员工、外聘人员等）和员工均不承担任何责任。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              12.0 责任限制和抗辩补偿
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            12.1
            除任何（a）与人身伤害（包括死亡）、不动产和有形动产的损害赔偿；以及（b）本协议及本协议任何补充或附属协议项下各方的抗辩补偿责任外，在任何情况下，各方及其关联机构均不对另一方或其关联机构因以下情形导致的损失和损害承担任何责任，无论是因合同、侵权（包括疏忽）或其他任何原因导致，即使已被告知其发生的可能性也无论其是否事先可预见：（1）数据丢失或损坏；（2）任何特殊的、偶然的、间接的、惩罚性的或后果性的损害赔偿；或（3）任何利润、业务、收益、商誉或预期节余的损失。
          </p>
          <p style={{ textAlign: 'justify' }}>
            12.2
            合作伙伴的抗辩和补偿。就贵方下列事项引起的或与之有关的任何和所有索赔、要求、诉讼、损害赔偿、损失、责任、罚款、处罚、判决或无论任何性质的费用（包括合理的律师费），贵方应为联想及其关联机构及他们各自的管理人员、董事和员工进行抗辩和补偿使其免受任何损失和损害：（a）违反本协议；（b）违反任何适用的法律、法规或命令，包括但不限于与进出口有关的法律、法规或命令；（c）违反任何声明或保证；（d）贵方实际或被指控侵犯任何知识产权；（e）人身伤害、死亡或财产损失；或（f）非法、不公平或欺骗的贸易行为。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              13.0 营销材料、和推广服务和商机服务
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            我们可能会不时向贵方发送一些联想和或/合作伙伴网络计划参加成员第三方合作伙伴的营销材料以及为贵方提供附加的推广服务，而不会就此另行向贵方收取费用（"推广服务"）。贵方知道并同意，我们可以通过电子传输、电子邮件、信函或其他方式向贵方发送上述营销和推广材料。贵方可随时通知我们停止发送上述材料。贵方了解并同意我们可能会不经另行通知随时调整我们提供上述推广服务的范围，某些推广服务可能仅针对新客户，贵方可能并不能获得某些或所有上述推广服务。如果贵方获得了我们和/或其他第三方合作伙伴网络计划参加成员提供的任何推广、产品报价或特别价格或条件，这些价格或条件仅适用于贵方，贵方应对这些价格和条件保密，未经我们和\或第三方合作伙伴合作伙伴网络计划参加成员事先书面明确同意，贵方不得将此类信息披露给任何第三方。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              14.0 期限、终止和变更
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            14.1
            本协议在贵方接受后生效直至根据本协议条款的规定终止。任何一方均可经提前一个月向另一方发出通知而部分或全部终止本协议，不需说明理由。
          </p>
          <p style={{ textAlign: 'justify' }}>
            14.2 本协议终止后，贵方使用联想合作伙伴计划账户的权利将立即终止。
          </p>
          <p style={{ textAlign: 'justify' }}>
            14.3
            本协议标题为"用户数据存储"、"知识产权"、"无保证声明"、"责任限制"及"其他"的条款在本协议到期或终止后继续有效。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              15.0 第三方软件和服务
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            15.1
            联想网站上可能提供对第三方网站的链接或引用，供贵方自愿选择使用。贵方点击这些链接会进入非由联想运营、管理和支持的第三方网站。这些链接或引用仅为用户方便而设置，并不表明我们对这些网站及其内容作出了任何认可、推荐或保证。对这些第三方网站的服务及其内容，联想不做任何陈述和保证，包括但不限于其可获得性和持续性。
          </p>
          <p style={{ textAlign: 'justify' }}>
            15.2
            贵方对第三方网站的使用可能受制于特定的法律条款并可能有许可及服务费产生。第三方网站的服务条款和隐私权政策可能与联想的规定有差异。贵方向这些第三方网站提交的或由其收集的贵方的个人信息，不适用联想的隐私权政策。如贵方选择使用该第三方网站，请贵方仔细阅读该第三方的相关服务条款和隐私权政策（如果有的话）。在进入或使用该第三方网站时，请贵方自行确定是否采取必要的防范措施，以免遭受病毒、蠕虫、木马和其他有害内容的侵害，联想不对这些网站的内容以及贵方对该网站的使用所导致的损害承担任何责任。
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}> </strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>16.0 一般条款</strong>
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.1
            修改。我们保留不时修改本协议（包括通用条款和特别条款）的权利，以反映相关法律及本计划的变化，这些修改不会给贵方带来不利影响。本协议的任何修改将在贵方以点击确认或继续使用本网站等方式接受后对贵方生效。如贵方不同意修改后的条款，应停止使用联想网站并退出本计划，本协议终止。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.2
            分包和转让。未经联想事先书面同意，贵方不得向第三方分派或转让贵方在本协议项下的任何权利。任何违反上述规定的分派或转让均属无效。联想可根据其业务模式安排关联机构或分包商执行本协议项下的部分或全部业务。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.3
            弃权；可分割。联想未行使或强制执行包含在本协议中的任何权利或条款，不视为对相关权利和条款的放弃。如本协议的任何规定或部分被有管辖权的裁判机构判定为不可强制执行，不影响本协议的其他部分的效力，本协议其他部分仍继续有效。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.4
            完整协议。本协议结合联想网站使用条款、联想隐私权政策及其他援引的条款，构成贵方与联想之间就本协议标的达成的全部协议，并取代贵方与联想此前或同时就本协议标的达成的任何其他谅解或协议，无论是口头的还是书面的。任何对本协议任何条款的弃权只能以书面方式为之并经联想签署后方为有效。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.5
            法律合规。任何一方均应遵守包括有关消费者保护在内的所有相关法律规定。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.6
            救济。贵方确认并同意，就贵方违反本协议项下义务，联想依法获得的救济可能是不充分的，为此，贵方同意，在根据本协议及相关法律规定获得的所有其他救济之外，联想可通过任何法律程序申请临时和永久禁令和/或特别履行，以强制执行本协议，不需要证明实际损害已经发生。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.7
            法律管辖和争议解决。本协议依中国大陆（为避免疑问，不包括香港、澳门和台湾）地区法律制定和解释，但不适用其法律冲突规则。因本协议及双方或双方各自关联机构援引或依据本协议签署的关联协议（包括但可能被不限于，补充协议、增补协议或其他类似文件，不论其订立日期是早于或晚于本协议的签订日期）的解释或执行引起的或与之相关的合同性争议，包括协议的存在、效力、解释、履行、违反或终止等，以及因本协议及本协议的关联协议引起的或与之相关的任何非合同性争议，经协商解决未果的，均提交北京仲裁委员会依照其当时有效的仲裁规则进行仲裁，仲裁地在北京，仲裁裁决是终局的，对双方均有约束力。上述约定并不禁止联想向任何有管辖权的法院申请禁制令或其他保护其知识产权的强制措施。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.8
            独立合同主体。本协议不构成，也不应被解释为在双方之间产生了雇佣、委托代理、合伙或合资关系。在与本协议相关的任何情况下，贵方与联想均为各自独立的合同主体。任何一方不得代表另一方行事，以任何方式使对方受到约束，或向任何第三方声称另一方将以任何方式对其行为（作为或不作为）负责。各方应自行承担与本协议及其在本协议项下的权利和义务有关的成本和费用。
          </p>
          <p style={{ textAlign: 'justify' }}>
            16.9
            协议起草。双方同意不因本协议由任何一方主要负责起草的事实，就本协议条款中的任何歧义对该方做不利的解释。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              联想企业智能体使用附加条款
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            初始发布：2024-07-23
            <br />
            最新更新：2024-07-23
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            本联想企业智能体使用附加条款（"本条款"）通过援引成为本网站
            <u style={{ color: 'rgb(54, 88, 226)' }}>
              《联想合作伙伴网络注册协议》
            </u>
            （以上统称为"网站协议"）的组成部分，并与网站协议的条款和条件结合，适用于您对我们网站人工智能功能的使用。本条款未定义的术语与网站协议使用的术语含义相同。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>目的和用途。</strong>
            联想可能基于人工智能功能为您提供反馈，此功能仅限用于为您提供联想产品和服务及其技术支持的信息。联想无意通过本网站提供任何互联网内容服务。您应仅限于为了解联想、联想产品和服务信息，寻求联想产品和服务支持的目的使用人工智能功能，我们可能会拒绝、忽略或屏蔽任何非为此目的的使用。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>您的内容</strong>
            。当您使用本网站人工智能功能时，可能会要求您输入您的内容，例如，文档、文本、图像或音视频文件等（包括任何输出参数，例如纵横比、样式等）（统称为"输入"）。本网站将使用您的输入来生成输出，例如，图像、文本、图形、音视频文件等（统称为"输出"）。除本条款另有规定者外，这些输入和输出均是您的内容，除本条款外，协议有关内容的规定均适用于这些输入和输出。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>输入</strong>
            。您应对您的输入负责。您声明和保证在使用本网站人工智能功能时应按照相关法律法规和本协议中的要求承担信息安全和其他义务。您承诺不采取任何以下行为：
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            (1)
            通过输入或其他方式，诱导生成违反相关法律法规、公共秩序、社会公德或侵犯他人合法权益的输出，包括但不限于：1)
            反对宪法所确定的基本原则；2)
            危害国家安全，泄露国家秘密，颠覆国家政权，推翻社会主义制度，破坏国家统一；3)
            损害国家荣誉和利益；4)
            歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉，否定英烈事迹，美化粉饰侵略战争行为；5)
            宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；6)
            煽动民族仇恨、民族歧视，破坏民族团结；7)
            破坏国家宗教政策，宣扬邪教和封建迷信；8)
            散布谣言、虚假有害信息，扰乱经济秩序和社会秩序，破坏社会稳定；9)
            宣扬淫秽、色情、赌博、暴力、凶杀、恐怖主义、极端主义或者教唆犯罪；10)
            煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；11)
            侮辱或者诽谤他人，泄露他人隐私，侵害他人名誉权、肖像权、隐私权、知识产权和其他合法权益；12)
            破坏国际关系以及国际和平稳定；13)
            含有法律、行政法规禁止的其他内容的信息。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            (2) 通过输入或其他方式，诱导生成不友善对话的输出，包括但不限于：1)
            人身攻击及辱骂他人；2)
            针对以下群体发表诅咒、歧视、漠视生命尊严等性质的言论，群体包括：不同特定国籍、地域、性别、性别认同、性倾向、种族、民族、健康状况、职业、年龄、信仰、残障群体等；3)
            对他人进行诅咒、恐吓或威胁；4)
            对他人创作的内容直接进行贬低性的评论；5)
            对他人使用粗俗用语，并产生了冒犯；6)
            针对以下群体发表偏见性质的言论，群体包括：特定国籍、地域、性别、性别认同、性倾向、种族、民族、健康状况、职业、年龄、信仰、残障群体等。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            (3) 干扰联想服务的正常运行、损害联想合法权益。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            (4) &nbsp;其他违法或侵权行为，例如实施垄断或不正当竞争行为等。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>输出。</strong>
            您自行对输出的创建和使用负责，并确保输出符合我们的条款。您使用人工智能功能获得有关联想及联想产品和服务信息，均基于您的输入创建。
            <strong style={{ fontFamily: '宋体' }}>
              这些内容仅供参考，不构成我们对相关产品和服务及输出内容的任何要约、推荐和保证。这些内容并不在任何程度上取代适用于这些产品和服务的保修政策、许可协议、服务条款以及您与您销售商的合同约定。虽然我们已经按照相关监管要求采取了相应合规措施，但因人工智能技术的限制，我们对输出内容的真实性、准确性、合法性及可用性不做任何明示或默示的保证。使用人工智能功能可能会产生非期待的或不适合某些用户的输出。输出可能不是唯一的，人工智能功能的其他用户可能会获得相同或相似的输出。输出内容可能不受知识产权保护。您应自行对内容进行判断并对其使用负责。您不得将输出内容理解为任何形式的专业建议和意见，并将其作为评判风险以及作出业务决策的依据，除非您进行了独立的咨询或研究。您将输出内容用于任何业务用途前，应征询合格专业人员的意见，按符合良好商业实践的流程进行审核和审批。对您参考、依赖或使用输出内容造成的任何损失、损害或其他后果，联想不承担任何责任。
            </strong>
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>使用规范。</strong>
            您不得删除或更改可能与输出内容一起提供的任何水印或标识（如有），或以其他方式试图在输出的来源方面误导他人，如您对外发布或传播输出的内容，您应当：（1）自行核查输出内容的真实性、准确性和完整性，避免传播虚假或误导性信息；（2）以显著方式标明该内容系由人工智能生成，以向公众提示内容来源；（3）避免发布和传播任何违反法律或本条款规定的内容。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>权利归属</strong>
            。我们基于您的输入返回的有关联想、联想产品和服务的信息（包括文字、图片及音视频等），其知识产权及其他权利和相关权益均归联想或联想的许可方拥有，除按本网站允许的目的使用外，我们并未授予您任何其他明示或默示的许可和权利。除此之外，您的内容中包含的任何已有知识产权及其他权利和相关权益（包括知识产权、肖像权等）始终归您或您的许可方所有，您对您的内容是否拥有相关权利和权益，由您自行判断及处理，我们对由此不承担任何责任。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>审核。</strong>
            联想可能会使用可用技术、供应商或流程来筛选和阻止任何不符合本条款规定的内容，包括但不限于，对输入和输出内容进行审核、建立风险过滤机制、建立违法内容特征库等，以及对违法和不当内容采取记录、屏蔽或删除等措施。我们可根据自己的判断随时不经另行通知限制、禁用、暂停或终止您对生成式人工智能功能的使用，但并不因此表明我们对您的内容承担任何义务和责任。请勿输入您无意让联想审核的内容。您不得采用任何方式对抗或试图绕过联想的过滤或其他审核机制，此类规避审核的行为包括但不限于：
          </p>
          <p style={{ textAlign: 'justify' }}>
            (1) 输入难以辨识涵义影响阅读体验的字符、数字及无意义乱码；
          </p>
          <p style={{ textAlign: 'justify' }}>
            (2) 使用变体、谐音等方式输入违规信息；以及
          </p>
          <p style={{ textAlign: 'justify' }}>
            (3) 使用复杂语义、长文本等方式以输入违规信息。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              内容使用的同意和许可。
            </strong>
            您同意，为改进本网站及相关技术，我们可以将您的输入、输出及其他生成信息做去标识化处理后再用于模型及算法训练，公开给其他用户并允许这些用户使用输入或输出来创建自己的内容。我们尊重并保护您的个人隐私。如我们为本条款的目的使用您的输入和输出，我们会对输入和输出中可能含有的个人信息进行脱敏处理，以保护您的个人信息。就您提交的输入以及相应的输出，您同意授予我们本条款规定的同意和许可，本同意和许可在本协议终止或到期后仍然有效。您应谨慎选择输入信息，特别是如果您的输入可能包含他人的个人信息，请务必取得相关方的授权或同意。更多关于用户个人信息保护的内容，请阅读联想隐私权政策声明，详细了解我们如何收集、使用、保护您的个人信息。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <strong style={{ fontFamily: '宋体' }}>
              不得进行Al或机器学习训练
            </strong>
            。您不得自行或允许第三方使用从本网站人工智能功能（包括任何输出）接收或派生的任何内容、数据、输出或其他信息，直接或间接创建、训练、测试或以其他方式改进任何机器学习算法或人工智能系统，包括任何架构、模型或权重。
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
          <p style={{ textAlign: 'justify' }}>
            <em>
              联想、Lenovo文字及徽标是联想集团所属企业的商标或注册商标。提及的其他商号、产品和服务名称可能是其他公司的商标。版权所有
              © 2024 联想集团所属企业。保留所有权利。
            </em>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <em>联想（北京）有限公司</em>
          </p>
          <p style={{ textAlign: 'justify' }}>
            <em>北京市海淀区西北旺东路10号联想集团全球总部西区 100094</em>
          </p>
          <p style={{ textAlign: 'justify' }}> </p>
        </div>
      </React.Antd.Modal>
    );
  }
}
